import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { corporateCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: number;
  title: string;
  field_news_images: string | null;
  field_news_date: string;
  field_news_title_en: string;
  field_news_title_ms: string | null;
  field_news_title_zh: string | null;
  field_news_description_en: string | null;
  field_news_description_ms: string | null;
  field_news_description_zh: string | null;
  published: boolean;
  field_news_cards_published: boolean;
  field_news_cards_created_at: string;
  field_news_cards_updated_at: string;
  item_count: number;
}

// edit api call
const fetchNewsDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await corporateCMSApi.get(`/api/news/allfields?id=${id}`);
  return response.data[0];
};

const useNewsDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["newsDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchNewsDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useNewsDocumentDetails };
